import "./style.scss";
import RedLineForTitle from "../../RedLineForTitle/RedLineForTitle";
import advantagesSlideBg from "@/src/assets/HomePage/Advantages/advantages-slide-bg.png";
import contactPhone from "@/src/assets/Contact/contact-phone.png";
import contactCooperation from "@/src/assets/Contact/contact-cooperation.png";
import contactVideo from "@/src/assets/Contact/contact-video.png";
import AdvantagesSliderPointSvg from "@/src/svg/AdvantagesSliderPointSvg";
import { Link } from "react-router-dom";

const ContactDesk = () => {
  return (
    <div className="container contact-desk">
      <RedLineForTitle title={"Контакты"} />
      <div className="contact-desk-items">
        <Link to={"/"} className="contact-desk-item">
          <div className="contact-desk-item-bg">
            <img src={advantagesSlideBg} alt="Contact Background" />
          </div>
          <div className="contact-desk-item-title">
            <p>Приемная комиссия</p>
          </div>
          <div className="contact-desk-item-point">
            <AdvantagesSliderPointSvg />
          </div>
          <div className="contact-desk-item-image">
            <img src={contactPhone} alt="Contact Phone" />
          </div>
        </Link>
        <Link to={"/"} className="contact-desk-item">
          <div className="contact-desk-item-bg">
            <img src={advantagesSlideBg} alt="Contact Background" />
          </div>
          <div className="contact-desk-item-title">
            <p>Отдел по сотрудничеству</p>
          </div>
          <div className="contact-desk-item-point">
            <AdvantagesSliderPointSvg />
          </div>
          <div className="contact-desk-item-image">
            <img src={contactCooperation} alt="Contact Cooperation" />
          </div>
        </Link>
        <Link to={"/"} className="contact-desk-item">
          <div className="contact-desk-item-bg">
            <img src={advantagesSlideBg} alt="Contact Background" />
          </div>
          <div className="contact-desk-item-title">
            <p>Социальные сети</p>
          </div>
          <div className="contact-desk-item-point">
            <AdvantagesSliderPointSvg />
          </div>
          <div className="contact-desk-item-image">
            <img src={contactVideo} alt="Contact Video" />
          </div>
        </Link>
        <Link to={"/"} className="contact-desk-item">
          <div className="contact-desk-item-bg">
            <img src={advantagesSlideBg} alt="Contact Background" />
          </div>
          <div className="contact-desk-item-title">
            <p>Адрес МшМБ</p>
          </div>
          <div className="contact-desk-item-point">
            <AdvantagesSliderPointSvg />
          </div>
          <div className="contact-desk-item-image">
            <img src={contactVideo} alt="Contact Video" />
          </div>
        </Link>
      </div>
    </div>
  );
};

export default ContactDesk;
